//CONTACTS
export const GET_USERS = "/users";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

// Defaults to the local API for development; set REACT_APP_API_BASE_URL for a deployed build.
export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://localhost:7274/api/v1";

//Login URL
export const LOGIN_URL = "/Authenticate/webuser";
export const OTP_URL = "/Authenticate/validatewebotp";
export const RESEND_OTP_URL = "/Authenticate/resendwebotp";

//Standard Types
export const GET_STANDARDS_LIST = "/standards/standardlists";
export const CREATE_STANDARD = "/standards/createstandard";
export const UPDATE_STANDARD = "/standards/updatestandard";
export const GET_STANDARD_DETAIL = "/standards/standard";

export const GET_SERVICECODE_LIST = "/standards/servicecodes";
export const CREATE_SERVICECODE = "/standards/createservicecode";
export const UPDATE_SERVICECODE = "/standards/updateservicecode";
export const GET_SERVICECODE_DETAIL = "/standards/servicecode";

export const GET_MANDATORYSERVICECODE_LIST = "/standards/mandatoryservicecodes";
export const CREATE_MANDATORYSERVICECODE =
  "/standards/createmandatoryservicecode";
export const UPDATE_MANDATORYSERVICECODE =
  "/standards/updatemandatoryservicecode";
export const GET_MANDATORYSERVICECODE_DETAIL =
  "/standards/mandatoryservicecode";

//checklist
export const GET_CHECKLIST_LIST = "/checklist/checklists";
export const CREATE_CHECKLIST = "/checklist/createchecklist";
export const UPDATE_CHECKLIST = "/checklist/updatechecklist";
export const GET_CHECKLIST_DETAIL = "/checklist/checklist";
export const DELETE_CHECKLIST = "/checklist/checklist";

export const GET_REFERENCE_LIST = "/checklist/references";
export const CREATE_REFERENCE = "/checklist/createreference";
export const UPDATE_REFERENCE = "/checklist/updatereference";
export const GET_REFERENCE_DETAIL = "/checklist/reference";

export const GET_AREA_LIST = "/checklist/areas";
export const CREATE_AREA = "/checklist/createarea";
export const UPDATE_AREA = "/checklist/updatearea";
export const GET_AREA_DETAIL = "/checklist/area";

export const GET_TOPIC_LIST = "/checklist/topics";
export const CREATE_TOPIC = "/checklist/createtopic";
export const UPDATE_TOPIC = "/checklist/updatetopic";
export const GET_TOPIC_DETAIL = "/checklist/topic";

export const GET_QUESTION_LIST = "/checklist/questions";
export const CREATE_QUESTION = "/checklist/createquestion";
export const UPDATE_QUESTION = "/checklist/updatequestion";
export const GET_QUESTION_DETAIL = "/checklist/question";
export const DELETE_QUESTION = "/checklist/question";

//master
export const GET_ACCOUNTTYPE_LIST = "/master/accounttypes";
export const GET_ACCOUNTSTATUS_LIST = "/master/accountstatuses";

export const CREATEUPDATE_MEETINGCATEGORY = "/master/meetingcategory";
export const GET_MEETINGCATEGORY_LIST = "/master/meetingcategories";
export const GET_MEETINGTYPES_LIST = "/master/meetingtypes";
export const GET_MEETINGSTATUS_LIST = "/master/meetingstatuses";
export const GET_MEETINGSUBSTATUS_LIST = "/master/meetingsubstatuses";
export const GET_MEETINGPRIORITY_LIST = "/master/meetingpriorities";

export const GET_DATAIMPORTTYPE_LIST = "/master/dataimporttypes";

export const GET_LEADSOURCE_LIST = "/master/leadsources";
export const GET_LEADSTATUS_LIST = "/master/leadstatuses";
export const GET_INDUSTRYTYPE_LIST = "/master/industrytypes";
export const GET_CLIENTTYPE_LIST = "/master/clienttypes";
export const GET_WORKTYPE_LIST = "/master/worktypes";
export const CREATEUPDATE_WORKTYPE = "/master/worktype";
export const CREATEUPDATE_CLIENTTYPE = "/master/clienttype";
export const CREATEUPDATE_INDUSTRYTYPE = "/master/industrytype";
export const GET_RISK_LIST = "/master/risks";
export const GET_RISKCATEGORY_LIST = "/master/riskcategories";
export const CREATEUPDATE_RISK = "/master/risk";

// Report template designer. Firm scope is established exclusively from the access token by the API.
export const REPORT_TEMPLATE_LIST = "/reporttemplate/templates";
export const REPORT_TEMPLATE_LOOKUPS = "/reporttemplate/templates/lookups";
export const GET_INSPECTIONTYPE_LIST = "/master/inspectiontypes";

export const GET_DEALTYPE_LIST = "/master/dealtypes";
export const GET_DEALSTATUS_LIST = "/master/dealstatuses";
export const GET_CALLTYPE_LIST = "/master/calltypes";
export const GET_CALLOUTCOME_LIST = "/master/calloutcomes";

export const GET_CATEGORY_LIST = "/master/categories";
export const GET_SUBCATEGORY_LIST = "/master/subcategories";
export const GET_TAG_LIST = "/master/taglist";
export const GET_DISTRICT_LIST = "/master/districts";
export const GET_LEVEL_LIST = "/master/evaluationlevels";
export const GET_STATUS_LIST = "/master/statuslevels";

export const GET_INSPECTION_CYCLE_STATUS_LIST =
  "/master/inspectioncyclestatuses";
export const GET_INSPECTION_CYCLE_TYPES_LIST = "/master/inspectioncycletypes";

export const CREATEUPDATE_CATEGORY = "/master/category";
export const CREATEUPDATE_SUBCATEGORY = "/master/subcategory";
export const CREATEUPDATE_TAG = "/master/tag";

//master folder
export const GET_FOLDER_LIST = "/folder/folderlist";
export const GET_FOLDER_TREE = "/folder/foldertree";
export const POST_FOLDER_CREATE = "/folder/createfolder";

//master financial year
export const GET_FINANCIALYEAR_LIST = "/master/financialyears";
export const CREATE_FINANCIALYEAR = "/master/financialyear";
export const UPDATE_FINANCIALYEAR = "/master/financialyear";
export const GET_FINANCIALYEAR_DETAIL = "/master/financialyear";

//review templates
export const GET_REVIEWTEMPLATE_LIST = "/reviewtemplate/templatelists";
export const CREATE_REVIEWTEMPLATE = "/reviewtemplate/createtemplate";
export const UPDATE_REVIEWTEMPLATE = "/reviewtemplate/updatetemplate";
export const GET_REVIEWTEMPLATE_DETAIL = "/reviewtemplate/template";
export const REVIEWTEMPLATE_CONFIGURATION = "/reviewtemplate/template";

export const GET_REVIEWTEMPLATEVERSION_LIST =
  "/reviewtemplate/templateversions";
export const CREATE_REVIEWTEMPLATEVERSION = "/reviewtemplate/createversion";
export const UPDATE_REVIEWTEMPLATEVERSION = "/reviewtemplate/updateversion";
export const GET_REVIEWTEMPLATEVERSION_DETAIL =
  "/reviewtemplate/templateversion";

export const GET_REVIEWTEMPLATEFIELD_LIST = "/reviewtemplate/templatefields";
export const CREATE_REVIEWTEMPLATEFIELD = "/reviewtemplate/createfield";
export const UPDATE_REVIEWTEMPLATEFIELD = "/reviewtemplate/updatefield";
export const GET_REVIEWTEMPLATEFIELD_DETAIL = "/reviewtemplate/templatefield";

//data import
export const GET_DATAIMPORT_LIST = "/dataimport/list";
export const GET_DATAIMPORT_REPORT = "/dataimport/report";
export const GET_DATAIMPORTMAPPING_LIST = "/dataimport/mappings";
export const UPLOAD_IMPORT_DEFINITION_TEMPLATE = "/importdefinition/template";
export const DOWNLOAD_IMPORT_DEFINITION_TEMPLATE = "/importdefinition/template";
export const SAVE_IMPORT_DEFINITION = "/importdefinition";
export const GET_IMPORT_DEFINITION_LIST = "/importdefinition";

// Inspection cycles
export const POST_INSPECTION_CYCLE_SEARCH = "/inspectioncycle/search";
export const SAVE_INSPECTION_CYCLE = "/inspectioncycle/save";
export const UPDATE_INSPECTION_CYCLE = "/inspectioncycle/save";
export const GET_INSPECTION_CYCLE_ENGAGEMENTS = "/inspectioncycle/engagements";

//clients
export const POST_CLIENT_SEARCH = "/client/search";
export const CREATEUPDATE_CLIENT = "/client/createupdate";
export const GET_CLIENT_DETAIL = "/client/details";
export const GET_NEXT_CLIENT_CODE = "/client/nextcode";
export const DELETE_CLIENT = "/client";

//Engagements
export const CREATE_ENGAGEMENT = "/engagement/create";
export const UPDATE_ENGAGEMENT = "/engagement/update";
export const UPDATE_ENGAGEMENT_DETAILS = "/engagement/update-details";
export const SEARCH_ENGAGEMENT = "/engagement/search";
export const GET_ENGAGEMENTLIST = "/engagement/list";
export const GET_ENGAGEMENTDETAIL = "/engagement/detail";
export const GET_UNASSIGNEDENGAGEMENTLIST = "/engagement/unassignedlist";
export const GET_UNGENERATEDENGAGEMENTLIST = "/engagement/ungeneratedlist";
export const DELETE_ENGAGEMENT = "/engagement/delete";
export const GET_ENGAGEMENT_REVIEW_READINESS = "/engagement/reviewreadiness";
export const GENERATE_ENGAGEMENTINSPECTION = "/engagement/generateinspection";
export const GET_ENGAGEMENTACTIVITYLIST = "/engagement/activitylist";
export const ADD_ENGAGEMENT_DOCUMENT = "/engagement/adddocument";
export const GET_ENGAGEMENT_DOCUMENTS = "/engagement/documents";
export const GET_ENGAGEMENT_DOCUMENT_FOLDERS = "/engagement/folders";
export const CREATE_ENGAGEMENT_DOCUMENT_FOLDER = "/engagement/folder";
export const UPDATE_ENGAGEMENT_DOCUMENT = "/engagement/updatedocument";
export const DELETE_ENGAGEMENT_DOCUMENT = "/engagement/document";

//Inspections
export const GET_INSPECTIONLIST = "/inspection/list";
export const GET_USERINSPECTIONLIST = "/inspection/assignedlist";
export const GET_INSPECTIONCHECKLIST = "/inspection/checklist";
export const GET_INSPECTION_FINDING_CONFIGURATION = "/inspection";

//Leads
export const POST_LEAD_SEARCH = "/lead/search";
export const GET_LEAD_DOCUMENT = "/lead/documents";
export const GET_LEAD_NOTES = "/lead/notes";
export const GET_LEAD_CALLLOG = "/lead/calllog";

//Contacts
export const POST_CONTACT_SEARCH = "/contact/search";

//Sales Accounts
export const POST_SALESACCOUNT_SEARCH = "/salesaccount/search";

//Sales Deals
export const POST_DEAL_SEARCH = "/deal/search";

//meeting
export const GET_ALL_MEETINGS = "/meeting/allmeetings";
export const GET_ACTIVE_MEETINGS = "/meeting/activemeetings";
export const GET_PAST_MEETINGS = "/meeting/pastmeetings";
export const GET_MEETING_DETAIL = "/meeting/meeting";
export const GET_MEETING_AGENDA = "/meeting/agenda";
export const GET_MEETING_SUMMARY = "/meeting/summary";
export const GET_MEETING_NOTES = "/meeting/notes";
export const GET_MEETING_COMMENTS = "/meeting/comments";
export const GET_MEETING_DOCUMENTS = "/meeting/documents";
export const GET_MEETING_PREVIOUSMEETINGS = "/meeting/previousmeetings";
export const GET_MEETING_FOLLOWUPMEETINGS = "/meeting/followupmeetings";
export const GET_MEETING_AGENDADETAIL = "/meeting/agendadetail";
export const GET_MEETING_AGENDACOMMENTS = "/meeting/agendacomment";
export const GET_MEETING_AGENDADOCS = "/meeting/agendadocs";
export const GET_MEETING_AGENDATASKS = "/meeting/agendatasks";

export const GET_MEETING_AGENDANOTES = "/meeting/agendanotes";
export const GET_MEETING_NOTESDETAIL = "/meeting/notesdetail";
export const GET_MEETING_NOTESDOCS = "/meeting/notesdocs";
export const GET_MEETING_NOTESTASKS = "/meeting/notestasks";

export const GET_MEETING_TASKS = "/meeting/tasks";
export const POST_MEETING_SEARCH = "/meeting/search";
export const POST_MEETING_PUBLISH = "/meeting/publish";

//document
export const POST_DOCUMENT_SEARCH = "/document/search";
export const GET_FOLDER_DOCUMENTS = "/document/folderdocuments";
export const GET_ALL_DOCUMENTS = "/document/alldocuments";
export const GET_DOCUMENT_FILES = "/document/documentfiles";
export const GET_DOCUMENT_DETAILS = "/document/document";
export const POST_DOCUMENT_ADDTAG = "/document/adddocumenttag";
export const POST_DOCUMENT_DELETETAG = "/document/deletedocumenttag";
export const GET_DOCUMENT_TAGS = "/document/documenttags";
export const POST_DOCUMENT_ADDPROPERTY = "/document/adddocumentproperty";
export const POST_DOCUMENT_DELETEPROPERTY = "/document/deletedocumentproperty";
export const GET_DOCUMENT_PROPERTIES = "/document/documentproperties";
export const GET_DOCUMENT_COMMENTS = "/document/documentcomments";

//Job
export const POST_TRIGGER_OCRJOB = "/job/startocrjob";

//MASTER
export const GET_MARITAL_STATUS = "/Master/maritalstatus";
export const GET_GENDER_TYPES = "/Master/gendertypes";
export const GET_ACCOUNT_GROUPS = "/Master/accountgroups";
export const GET_EMPLOYEE_TYPE = "/Master/employeetypes";
export const GET_MASTER_DISTRICTS = "/Master/districts";
export const GET_EVALUATION_LEVELS = "/Master/evaluationlevels";

//workflow
export const GET_WORKFLOW_WORKFLOWS = "/Workflow/workflows";

//Application
export const GET_ROLES = "/Application/userroles";
export const GET_CERTIFICATES = "/application/certificates";
export const GET_NOTIFICATIONS = "/application/notifications";

//company
export const GET_GROUPS = "/company/groups";
export const GET_DESIGNATIONS = "/company/designations";
export const GET_DESIGNATIONDETAIL = "/company/designationdetail";
export const GET_COMPANY_LIST = "/company/list";
export const GET_COMPANY_RELATEDLIST = "/company/relatedlist";
export const GET_COMPANY_DETAILS = "/company/details";
export const PROVISION_ACTIVE_FIRM_CATALOGUES =
  "/company/catalogue/provision-active-firms";
export const CREATE_GROUP = "/company/creategroup";
export const POST_DESIGNATION = "/company/designation";
export const GET_LOCATIONS = "/Company/locations";
export const GET_USER_LOCATIONS = "/Company/userlocations";
export const GET_LOCATION = "/Company/location/";
export const CREATEUPDATE_LOCATION = "/Company/location";
